import { GlobalStyle } from '../../core/types/Config';

export const colorsOverride: GlobalStyle = {
  textColor: 'rgba(28, 37, 46, 1)',
  textSubtitleColor: 'rgba(109, 109, 109, 1)',
  backgroundColor: 'rgb(255,255,255)',
  sidebarFullBackgroundColor: 'rgba(72,110,245,0.2)',
  inputFocusColor: 'rgb(33, 43, 54)',
  inputBorderColor: 'rgba(145, 158, 171, 0.2)',
  inputLabelColor: 'rgb(145, 158, 171)',
  inputErrorColor: 'rgb(255, 86, 48)',
  buttonContainedPrimaryColor: 'rgb(72,110,245)',
  buttonContainedPrimaryColorHover: 'rgb(52,94,243)',
  buttonContainedErrorColor: 'rgb(183, 29, 24)',
  buttonContainedErrorColorHover: 'rgb(250, 59, 16)',
  buttonContainedErrorTextColor: 'rgb(255,255,255)',
  buttonOutlinedPrimaryColor: 'transparent',
  buttonOutlinedPrimaryColorBorder: 'rgba(145,158,171,0.32)',
  buttonOutlinedPrimaryColorHover: 'rgba(145, 158, 171, 0.08)',
  buttonErrorBackgroundColor: 'rgba(255, 86, 48, 0.16)',
  buttonErrorBackgroundColorHover: 'rgba(255, 86, 48, 0.32)',
  buttonErrorColor: 'rgb(183,29,24)',
  buttonSoftBackgroundColor: 'rgba(145, 158, 171, 0.08)',
  buttonSoftBackgroundHoverColor: 'rgba(145, 158, 171, 0.24)',
  buttonSuccessBackgroundColor: 'rgb(0, 167, 111)',
  buttonSuccessBackgroundColorHover: 'rgb(0, 120, 103)',
  buttonSuccessColor: 'rgb(255, 255, 255)',
  dividerColor: 'rgb(145, 158, 171)',
  dividerBorderColor: 'rgba(145, 158, 171, 0.2)',
  dividerBorderColorLighter: 'rgba(145, 158, 171, 0.1)',
  dividerBorderColorLightest: 'rgba(0, 0, 0, 0.04)',
  progressBackgroundColor: 'rgba(33, 43, 54, 0.3)',
  progressColor: 'rgb(33, 43, 54)',
  tabDefaultColor: 'rgba(28, 37, 46, 1)',
  tableHeadBackgroundColor: 'rgba(72,110,245,0.2)',
  tableHeadColor: 'rgba(28, 37, 46, 1)',
  tableHeadBulkColor: 'rgba(45, 45, 45, 1)',
  tableHeadBulkBackgroundColor: 'rgba(72,110,245,0.4)',
  tableLineBorderColor: 'rgb(241, 243, 244)',
  tableLineHighlightColor: 'rgba(0, 167, 111, 0.08)',
  tableLineHoverColor: 'rgba(145, 158, 171, 0.08)',
  alertPrimaryBackgroundColor: 'rgb(33, 43, 54)',
  alertPrimaryBackgroundColorHover: 'rgba(33, 43, 54, 0.16)',
  alertPrimaryColor: 'rgb(255,255,255)',
  alertInfoBackgroundColor: 'rgba(0, 184, 217, 0.16)',
  alertInfoColor: 'rgb(0, 140, 165)',
  alertInfoBackgroundColorHover: 'rgb(0, 184, 217)',
  alertInfoColorHover: 'rgb(30, 40, 50)',
  alertErrorBackgroundColor: 'rgba(255, 86, 48, 0.16)',
  alertErrorColor: 'rgb(183,29,24)',
  alertErrorBackgroundColorHover: 'rgb(255, 86, 48)',
  alertErrorColorHover: 'rgb(255,255,255)',
  alertWarningBackgroundColor: 'rgba(255, 171, 0, 0.16)',
  alertWarningColor: 'rgb(183,110,0)',
  alertWarningBackgroundColorHover: 'rgb(255, 171, 0)',
  alertWarningColorHover: 'rgb(33, 43, 54)',
  alertWarningSecondaryBackgroundColor: 'rgba(255, 145, 0, 0.16)',
  alertWarningSecondaryColor: 'rgb(165, 90, 0)',
  alertWarningSecondaryBackgroundColorHover: 'rgb(255, 145, 0)',
  alertWarningSecondaryColorHover: 'rgb(30, 40, 50)',
  alertSuccessBackgroundColor: 'rgba(34, 197, 94, 0.16)',
  alertSuccessColor: 'rgb(17,141,87)',
  alertSuccessBackgroundColorHover: 'rgba(34, 197, 94)',
  alertSuccessColorHover: 'rgb(255, 255, 255)',
  alertSecondaryBackgroundColor: 'rgba(157, 54, 224, 0.16)',
  alertSecondaryColor: 'rgb(120, 40, 180)',
  alertSecondaryBackgroundColorHover: 'rgb(157, 54, 224)',
  alertSecondaryColorHover: 'rgb(30, 40, 50)',
  breadcrumbSecondaryColor: 'rgba(161, 161, 161, 1)',
  switcherColor: 'rgb(72,110,245)',
  switcherThumbColor: 'rgb(255, 255, 255)',
  switcherTrackColor: 'rgba(145, 158, 171, 0.48)',
  avatarPlaceholderColor: 'rgb(255,255,255)',
  avatarPlaceholderBackgroundColor: 'rgba(20, 26, 33, 0.64)',
  countryBackgroundColor: 'rgb(244, 246, 248)',
  noDataBackgroundColor: 'rgba(145, 158, 171, 0.04)',
  noDataBorderColor: 'rgba(145, 158, 171, 0.08)',
  noDataColor: 'rgb(145, 158, 171)',
  popoverArrowBorderColor: 'rgba(145, 158, 171, 0.12)',
  popoverArrowBackgroundColor: 'rgba(255, 255, 255, 0.8)',
  sidebarColor: 'rgba(45, 45, 45, 1)',
  sidebarBackgroundColor: 'rgba(72,110,245,0.5)',
  sidebarGroupColor: 'rgb(145, 158, 171)',
  sidebarExpandColor: 'rgba(255, 255, 255, 0.48)',
  topNavigationBackgroundColor: 'rgba(255, 255, 255, 0.8)',
  checkboxColor: 'rgb(72,110,245)',
  tooltipColor: 'rgb(33, 43, 54)',
  pickerActiveBackgroundColor: 'rgb(72,110,245)',
  pickerActiveBackgroundHoverColor: 'rgb(49,92,244)',
  pickerHoverColor: 'rgba(72,110,245,0.08)',
  loaderBackgroundColor: 'rgba(255, 255, 255, 0.8)',
  kanbanCardCountColor: 'rgba(145, 158, 171, 0.16)',
  kanbanCardCountBorderColor: 'rgba(145, 158, 171, 0.24)',
  disabledColor: 'rgb(145, 158, 171)',
  primaryLightColor: 'rgb(72,110,245)',
  primaryLightColorHover: 'rgba(72,110,245,0.47)',
  tableOutlinedBorderColor: 'rgba(145, 158, 171, 0.16)',
};
